<div class="container component">

    <div class="header">
        <div class="buttonBack" (click)="onClickBack($event)">
            <i class="fa fa-arrow-right" aria-hidden="true"></i>
            <i class="fa fa-times" aria-hidden="true"></i>
        </div>
    </div>

    <div class="block" *ngIf="selectedRouteExpand != null" (dragover)="dragover($event)" (drop)="dropAtZone($event)">

        <shared-trucking-route-card class="routeItem" [route]="selectedRouteExpand"></shared-trucking-route-card>
        <actions [actionstrip]="actions" (clickAction)="onClickPreAction($event)">
        </actions>
        <div class="linia bar baroptions">
            <options class="slim mixed-text-icon" [optionstrip]="options" (clickOption)="onClickOption($event)"></options>
        </div>
    
        <ng-container *ngIf="actualOptionId==='LOAD'">
            <shared-trucking-route-panel-load class="block-option" [selectedRouteExpand]="selectedRouteExpand">
            </shared-trucking-route-panel-load>
        </ng-container>
        <ng-container *ngIf="actualOptionId==='ROUTE'">
            <shared-route-info-component class="aside nolinks" [routeId]="selectedRouteExpand.routeId">
            </shared-route-info-component>
        </ng-container>
        <ng-container *ngIf="actualOptionId==='PARTNERS'">
            <shared-route-partner-selector class="withoutexwork withoutexternaldriver"
            [routeId]="selectedRouteExpand.routeId" [readonly]="true"></shared-route-partner-selector>
        </ng-container>
        <ng-container *ngIf="actualOptionId==='DRIVER'">   
            <shared-driverplate class="block-option" [showCarrierCard]="false" [onlydriver]="true"
            [routeId]="selectedRouteExpand.routeId"></shared-driverplate>
        </ng-container>
        <ng-container *ngIf="actualOptionId==='CHAT'">
            <shared-chat class="block-option" [forcedOwnerParticipant]="forcedOwnerParticipant" [notes]="true"
                (clickParticipant)="clickParticipant($event)">
            </shared-chat>
        </ng-container>
        <ng-container *ngIf="actualOptionId==='DOCUMENT'">
            
        </ng-container>

        <confirmation-dialog *ngIf="truckingAction" [expanded]="askingAction" helptitleresource="{{ truckingAction.titleResource }}"
            helpresource="{{ truckingAction.helpResource }}" (onConfirm)="onClickAction(truckingAction.action)"
            (onCancel)="askingAction = false"></confirmation-dialog>
    </div>

</div>